import { SaveBar } from "@shopify/app-bridge-react"
import React, { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"

interface PageSaveBarProps {
  onSave: () => void
  onDiscard: () => void
  show?: boolean
  unlocking?: boolean
  loading?: boolean
  disabled?: boolean
  saveBarId?: string
}

const PPSaveBar: React.FC<PageSaveBarProps> = ({
  onSave,
  onDiscard,
  show = false,
  unlocking = false,
  loading = false,
  disabled = false,
  saveBarId = "page-save-bar",
}) => {
  const { t } = useTranslation(["common"])
  const saveButtonRef = useRef<HTMLButtonElement | null>(null)

  // 根据 show 和 unlocking 状态决定是否显示 SaveBar
  const isOpen = show && !unlocking

  // 使用 ref 手动控制 loading 和 disabled 状态
  useEffect(() => {
    const btn = saveButtonRef.current

    if (!btn) return

    if (loading) {
      btn.setAttribute("loading", "true")
      btn.disabled = true
    } else {
      btn.removeAttribute("loading")
      btn.disabled = disabled
    }
  }, [loading, disabled])

  return (
    <SaveBar id={saveBarId} open={isOpen}>
      <button
        ref={saveButtonRef}
        variant="primary"
        onClick={onSave}
      >
        {t("common:Save")}
      </button>
      <button onClick={onDiscard}>
        {t("common:Discard")}
      </button>
    </SaveBar>
  )
}

export default PPSaveBar
